import {useCallback} from "react"
import {useNavigate, useSearchParams} from "react-router-dom"
import {getTimeFromNow} from "../../../../functions/time"
import {PullRequest} from "../../../../models/PullRequest.model"
import styles from "./index.module.scss"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCodePullRequest, faArrowLeftLong} from "@fortawesome/free-solid-svg-icons"

interface ListPRProps {
  pullRequests: PullRequest[]
}

export const ListPR = (props: ListPRProps) => {
  const {pullRequests} = props
  const openPRs = pullRequests.filter(pr => pr.status === "open")
  const closedPRs = pullRequests.filter(pr => pr.status === "closed")
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedStatus = searchParams.get("status") || "open"
  const selectedPRs = selectedStatus === "closed" ? closedPRs : openPRs

  const onClickCreatePR = useCallback(() => {
    navigate("./new")
  }, [navigate])

  const onClickPRRow = useCallback((prId: string) => {
    navigate(`./${prId}`)
  }, [navigate])

  return (
    <div className={styles.Container}>
      <div className={styles.HeaderRow}>
        <div className={styles.HeaderTitle}>
          There are {openPRs.length} Open Pull Requests
        </div>
        <div className={styles.CreateButton}
             onClick={onClickCreatePR}>
          New PR
        </div>
      </div>

      <div className={styles.PullRequestContainer}>
        <div className={styles.StatusOptionBar}>
          <div className={selectedStatus === "open" ? styles.ActiveStatus : styles.StatusOption}
               onClick={() => setSearchParams({status: "open"})}
          >
            Open ({openPRs.length})
          </div>
          <div className={selectedStatus === "closed" ? styles.ActiveStatus : styles.StatusOption}
               onClick={() => setSearchParams({status: "closed"})}
          >
            Closed ({closedPRs.length})
          </div>
        </div>

        {
          selectedPRs.map((pr) => {
            const truncId = pr.id.slice(0, 8)
            return (
              <div className={styles.PullRequestRow} key={pr.id}>
                <div className={styles.PullRequestDetails}>
                  <div className={styles.FirstRow}>
                    <FontAwesomeIcon icon={faCodePullRequest} className={styles.Icon}/>
                    <div className={styles.PullRequestTitle}>
                      {pr.title}
                    </div>
                  </div>

                  <div className={styles.SecondRow}>
                    <div>#{truncId} opened {getTimeFromNow(pr.createAt, true)} by @{pr.authorName}</div>
                  </div>

                  <div className={styles.ThirdRow}>
                    <div className={styles.BranchChip}>{pr.baseBranch}</div>
                    <FontAwesomeIcon icon={faArrowLeftLong}/>
                    <div className={styles.BranchChip}>{pr.mergeBranch}</div>
                  </div>
                </div>

                <button className={styles.ViewDetails} onClick={() => onClickPRRow(pr.id)}>
                  View Details
                </button>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

